export interface BlogPost {
  id: string
  title: string
  category: string
  date: string
  image: string
  excerpt: string
  readTime: string
}

export const blogCategories = [
  'All', 'AI', 'CRM', 'Design', 'For beginners', 'Integrations',
  'Marketing', 'Mobile apps', 'News', 'Online store', 'Optimization',
  'Security', 'SEO', 'Technology', 'Tools', 'Trends'
]

export const blogPosts: BlogPost[] = [
  {
    id: 'ai-chatbots-2026',
    title: 'AI Chatbots for Business: How to Automate Customer Support in 2026',
    category: 'AI',
    date: 'June 15, 2026',
    image: '/images/blog-tech-support.jpg',
    excerpt: 'Discover how modern AI chatbots powered by GPT-4 and LangChain can handle 80% of customer inquiries while reducing support costs by up to 60%.',
    readTime: '8 min read'
  },
  {
    id: 'saas-mvp-guide',
    title: 'From Idea to Launch: The Complete Guide to Building Your SaaS MVP',
    category: 'Technology',
    date: 'June 10, 2026',
    image: '/images/blog-speed.jpg',
    excerpt: 'Learn the proven framework for validating, building, and launching a SaaS product in 90 days — from market research to first paying customers.',
    readTime: '12 min read'
  },
  {
    id: 'ecommerce-conversion',
    title: '15 E-Commerce Conversion Strategies That Actually Work in 2026',
    category: 'Online store',
    date: 'June 5, 2026',
    image: '/images/blog-leads.jpg',
    excerpt: 'Data-backed tactics to increase your online store conversion rate — from checkout optimization to personalization and abandoned cart recovery.',
    readTime: '10 min read'
  },
  {
    id: 'crm-small-business',
    title: 'Why Every Small Business Needs a Custom CRM System',
    category: 'CRM',
    date: 'May 28, 2026',
    image: '/images/deepfake.jpg',
    excerpt: 'Off-the-shelf CRMs waste time and money. Here is why a custom-built CRM tailored to your workflow delivers 3x better ROI than Salesforce or HubSpot.',
    readTime: '7 min read'
  },
  {
    id: 'landing-page-roi',
    title: 'The Anatomy of a High-Converting Landing Page: 2026 Edition',
    category: 'Marketing',
    date: 'May 20, 2026',
    image: '/images/euduco.jpg',
    excerpt: 'Break down the exact elements that separate 2% conversion rates from 15% — with real examples, A/B test results, and actionable templates.',
    readTime: '9 min read'
  },
  {
    id: 'branding-startups',
    title: 'Startup Branding 101: Building a Brand That Investors and Customers Love',
    category: 'Design',
    date: 'May 12, 2026',
    image: '/images/validsoft.jpg',
    excerpt: 'How to create a compelling brand identity from day one — positioning, visual design, voice, and the mistakes that kill startup brands early.',
    readTime: '11 min read'
  },
  {
    id: 'ai-automation-workflows',
    title: '5 Business Processes You Should Automate with AI Today',
    category: 'AI',
    date: 'May 5, 2026',
    image: '/images/blog-tech-support.jpg',
    excerpt: 'From lead qualification to content generation — these AI automation workflows are saving companies 20+ hours per week on repetitive tasks.',
    readTime: '6 min read'
  },
  {
    id: 'nextjs-vs-react',
    title: 'Next.js vs React: Which One Should You Choose for Your Project?',
    category: 'Technology',
    date: 'April 28, 2026',
    image: '/images/blog-speed.jpg',
    excerpt: 'A technical deep-dive comparing performance, SEO, development speed, and use cases to help you make the right framework decision.',
    readTime: '8 min read'
  },
  {
    id: 'shopify-customization',
    title: 'Beyond Templates: Advanced Shopify Customization for Enterprise Brands',
    category: 'Online store',
    date: 'April 20, 2026',
    image: '/images/blog-leads.jpg',
    excerpt: 'When your Shopify store outgrows themes — headless architecture, custom apps, API integrations, and performance tuning for scale.',
    readTime: '10 min read'
  },
]
